module.exports = __webpack_public_path__ + "img/pr-5.a94af31a.png";